var map = {
	"./en/DocumentPage.json": [
		90076,
		76
	],
	"./en/ErrorPages.json": [
		8964,
		8964
	],
	"./en/ExpiredDocsStatusPage.json": [
		11913,
		1913
	],
	"./en/HomePage.json": [
		76762,
		6762
	],
	"./en/LogTableDocuments.json": [
		43142,
		3142
	],
	"./en/Menu.json": [
		53657,
		3657
	],
	"./en/ProjectPage.json": [
		35840,
		5840
	],
	"./en/SyncProjectPage.json": [
		37997,
		7997
	],
	"./en/UseProyectDataOptions.json": [
		29417,
		9417
	],
	"./en/UserPage.json": [
		8522,
		8522
	],
	"./en/Workload.json": [
		85527,
		5527
	],
	"./en/dates.json": [
		62975,
		2975
	],
	"./en/pagination.json": [
		25446,
		5446
	],
	"./en/translation.json": [
		44745,
		4745
	],
	"./es/DocumentPage.json": [
		90077,
		77
	],
	"./es/ErrorPages.json": [
		84065,
		4065
	],
	"./es/ExpiredDocsStatusPage.json": [
		60098,
		98
	],
	"./es/HomePage.json": [
		69503,
		9503
	],
	"./es/Menu.json": [
		98464,
		8464
	],
	"./es/ProjectPage.json": [
		56239,
		6239
	],
	"./es/SyncProjectPage.json": [
		40834,
		834
	],
	"./es/UseProyectDataOptions.json": [
		22230,
		2230
	],
	"./es/UserPage.json": [
		93791,
		3791
	],
	"./es/Workload.json": [
		84126,
		4126
	],
	"./es/dates.json": [
		47464,
		7464
	],
	"./es/pagination.json": [
		10883,
		883
	],
	"./es/translation.json": [
		70650,
		650
	],
	"./pt/DocumentPage.json": [
		37073,
		7073
	],
	"./pt/ErrorPages.json": [
		17581,
		7581
	],
	"./pt/ExpiredDocsStatusPage.json": [
		67638,
		7638
	],
	"./pt/HomePage.json": [
		67011,
		7011
	],
	"./pt/Menu.json": [
		32636,
		2636
	],
	"./pt/ProjectPage.json": [
		99307,
		9307
	],
	"./pt/SyncProjectPage.json": [
		22070,
		2070
	],
	"./pt/UseProyectDataOptions.json": [
		48898,
		8898
	],
	"./pt/UserPage.json": [
		34075,
		4075
	],
	"./pt/Workload.json": [
		47986,
		7986
	],
	"./pt/dates.json": [
		97028,
		7028
	],
	"./pt/pagination.json": [
		32647,
		2647
	],
	"./pt/translation.json": [
		80782,
		782
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8631;
module.exports = webpackAsyncContext;